/**
 * Rocnovel 品牌 - Tags 页面配置
 */
import { tagsCommonConfig } from './common'
import type { TagsPageConfig } from './types'

/**
 * Rocnovel 品牌特定主题配置
 */
export const theme = {
  popupTagBgColor: '#EFECF6',
  popupTagColor: '#65686F',
  popupTagActiveColor: '#FFFFFF',

  filterBgColor: '#F5F7FB',
  filterActiveBgColor: '#F0EAFF',
  filterColor: '#65686F',
  filterActiveColor: '#9875FB',
} as const

export const tagsConfig: TagsPageConfig = {
  theme,
  texts: tagsCommonConfig.texts,
}
